import { createEffect, createRoot } from "solid-js"
import { MeshLambertMaterial } from "three"
import type { Engine } from "../../core/engine/Engine.type"
import type { Entity } from "../../core/entity/index"
import findById from "../../core/findById"

export const NEUTRAL_PLAYER_COLOR = 0x888888

export default function getEntityColor1Material(
  engine: Engine,
  entity: Entity,
  fn?: (material: MeshLambertMaterial) => void,
): MeshLambertMaterial {
  const material = new MeshLambertMaterial()
  material.name = 'PlayerColor1'
  createRoot((disposeRoot) => {
    createEffect(() => {
      // console.log('getEntityColor1Material.effect')
      const player = findById(engine.state.players, entity.player_id)
      material.color.set(player ? player.color1 : NEUTRAL_PLAYER_COLOR)
      material.userData.playerId = entity.player_id
      fn?.(material)
    })
    material.addEventListener('dispose', disposeRoot)
  })
  return material
}
